import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import jobTitle from "../../../assets/img/Group 532 (3).png";
import Video from "../../../assets/img/welcome.mp4";
import Header from "../../Header";
import Footer from "../../footer";
import { API_BASE_URL } from "../../../config/config";
import "../jobcomp/style.css";

const JobList = () => {
  const { id } = useParams();
  const [vacancies, setVacancies] = useState([]);
  const [category, setCategory] = useState(null);
  const { t, i18n } = useTranslation();

  const languageMap = { tj: 1, ru: 2, en: 3 };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(
        `${API_BASE_URL}/api/events/events-vacancies?lang=${langCode}&categoryId=${id}&page=1`,
        { headers: { accept: "text/plain", "api-version": "1.0" } }
      )
      .then((res) => setVacancies(res.data.enttities || []))
      .catch((err) => console.error("Error fetching vacancies:", err));
  }, [id, i18n.language]);

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    axios
      .get(`${API_BASE_URL}/api/categories/${id}?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((res) => setCategory(res.data))
      .catch((err) => console.error("Error fetching category:", err));
  }, [id, i18n.language]);

  return (
    <div className="joblist-page d-flex flex-column">
      <div className="position-relative text-white" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>

      <div className="container joblist-main mt-5">
        <div className="row" style={{ marginTop: "-100px" }}>
          <div className="col-12 mb-4">
            <div className="d-flex align-items-center mb-3">
              <img className="joblist-icon" src={jobTitle} alt="Category" />
              <h3 className="joblist-title ms-2">
                {category ? category.name : t("Agency Vacancies")}
              </h3>
            </div>
            <span className="joblist-description">
              {category ? category.desc : t("AgencyDecr")}
            </span>
          </div>
        </div>

        <div className="row">
          {vacancies.length > 0 ? (
            vacancies.map((item) => (
              <div className="col-md-3 mb-4" key={item.id}>
                <div className="card joblist-card h-100 d-flex flex-column shadow-sm">
                  <div className="card-body d-flex flex-column">
                    <h5
                      className="joblist-card-title text-black"
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <div className="mt-auto">
                      <Link
                        to={`/job/show/${item.id}`}
                        className="btn joblist-btn w-100"
                      >
                        {t("MoreDetails")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted">{t("No jobs available")}</p>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default JobList;
